import { render, staticRenderFns } from "./SharedBookings.vue?vue&type=template&id=fed5f6ea&"
import script from "./SharedBookings.vue?vue&type=script&lang=js&"
export * from "./SharedBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports